import { render, staticRenderFns } from "./NewsBoardSearch.vue?vue&type=template&id=2922d996&scoped=true&"
import script from "./NewsBoardSearch.vue?vue&type=script&lang=ts&"
export * from "./NewsBoardSearch.vue?vue&type=script&lang=ts&"
import style0 from "./NewsBoardSearch.vue?vue&type=style&index=0&id=2922d996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922d996",
  null
  
)

export default component.exports